import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import React from "react";

const theme = createTheme({
  overrides: {
    MuiStepLabel: {
      root: {
        height: "10px",
      },
      label: {
        fontSize: "20px",
        color: "black",
        
        ["@media only screen and (min-width: 320px) and (max-width: 812px)"]: {
          // eslint-disable-line no-useless-computed-key
          fontSize: "12px",
        },
        ["@media only screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) "]: {
          // eslint-disable-line no-useless-computed-key
          fontSize: "17px",
        },
        ["@media only screen and (min-width: 375px) and (max-width: 812px)"]: {
          // eslint-disable-line no-useless-computed-key
          fontSize: "12px",
        },
      },
    },
    MuiStepConnector: {
      vertical: {
        padding: "0px",
        marginLeft: "5.4px",
      },
      lineVertical: {
        borderColor: "red",
        minHeight: "35px",
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  icon: {
    color: "white",
    border: "1px solid red",
    borderRadius: "50%",
    fontSize: "10px",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

export default function VerticalLinearStepper(props) {
  const classes = useStyles();
  /// const steps = getSteps();

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <Stepper
          style={{ padding: "0px" }}
          activeStep={-1}
          orientation="vertical"
        >
          {props.stepper.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconProps={{
                  classes: { root: classes.icon },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </ThemeProvider>
    </div>
  );
}
